module.exports = __webpack_public_path__ + "img/Aixin_Life.50b7481a.jpg";